// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"7f9a563d","135":"c98a6cd1","224":"a3c3bfa4","481":"2657f0f1","513":"98b0c961","567":"6e67b237","773":"e5c232d6","962":"0a706e83"}[chunkId] + ".chunk.js";
};